import { render, staticRenderFns } from "./CardSupplier.vue?vue&type=template&id=876b7b84&scoped=true"
import script from "./CardSupplier.vue?vue&type=script&lang=js"
export * from "./CardSupplier.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "876b7b84",
  null
  
)

export default component.exports